import { axios } from '@lib/axios';

import {
    CdaDeliveryResponsesViewModel,
    CdaDeliveryRetryForm,
    CdaDeliveryRetryResponse,
    CdaDeliveryStatusesViewModel,
    CdaGenerationForm,
    EntryCdaCreationParams,
    GeneratedCdaResponse,
    SignedCdaForm,
} from 'chaika-types';

const BASE_URL = '/api/egisz';

export const CDA_NOT_AVAILABLE_ERROR_CODE = 'CdaNotAvailable';

export class EgiszApi {
    public static async generateCda(entryId: string): Promise<GeneratedCdaResponse> {
        const body: CdaGenerationForm = { entryId };
        const res = await axios.post<GeneratedCdaResponse>(`${BASE_URL}/cda`, body);

        return res.data;
    }

    public static async saveSignedCda(
        entryId: string,
        cda: EntryCdaCreationParams,
    ): Promise<CdaDeliveryStatusesViewModel> {
        const body: SignedCdaForm = { entryId, ...cda };
        const res = await axios.post<CdaDeliveryStatusesViewModel>(`${BASE_URL}/cda/signed`, body);

        return res.data;
    }

    public static async retryRemdDeliveries(entryIds: string[]): Promise<CdaDeliveryRetryResponse> {
        const body: CdaDeliveryRetryForm = { entryIds };
        const res = await axios.post<CdaDeliveryRetryResponse>(`${BASE_URL}/cda-delivery/remd/retry`, body);

        return res.data;
    }

    public static async retryIemkDeliveries(entryIds: string[]): Promise<CdaDeliveryRetryResponse> {
        const body: CdaDeliveryRetryForm = { entryIds };
        const res = await axios.post<CdaDeliveryRetryResponse>(`${BASE_URL}/cda-delivery/iemk/retry`, body);

        return res.data;
    }

    public static async getCdaDeliveryResponses(entryId: string): Promise<CdaDeliveryResponsesViewModel> {
        const res = await axios.get<CdaDeliveryResponsesViewModel>(`${BASE_URL}/cda-delivery/${entryId}`);

        return res.data;
    }
}
